// extracted by mini-css-extract-plugin
export default {"bioChipBox":"fBKKZU8NJluSnKWSss7u","bioDescription":"jUyJjY6q4ftxR_nkK_k4"};